import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import ReduxActions from 'reduxActions';
import BulkEditField from './field';

class BulkEditDropdownPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        date: new Date(),
      },
    };
  }

  _onFormChange(fieldName, value) {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        [fieldName]: value,
      },
    }));
  }

  _editMultiple() {
    this.props.dispatch(ReduxActions.task.editMultiple(this.props.ids, {
      time_from: this.state.form.date,
      time_to: this.state.form.date,
    }))
      .then((result) => {
        if (result.failed_count === 0) {
          Utils.SuccessMessage.SuccessMessageManager.flash((
            <div className="vf-task__bulk-edit__success-message">
              <div className="vf-task__bulk-edit__success-message__icon">
                <i className="versa-completed" />
              </div>
              {
                Utils.TranslationHelper.replaceTag(this.props.strings.page.dateWithoutSkipSuccess, {
                  count: result.successful_count,
                })
              }
            </div>
          ));
        } else {
          Utils.Dialog.DialogManger.open((
            <div className="vf-task__bulk-edit__dialog">
              <div className="vf-task__bulk-edit__dialog__header">
                <Components.CircleIcon
                  className="vf-task__bulk-edit__dialog__header__icon"
                  iconClassName="versa-completed"
                  innerIconColor={Theme.Color.$gold}
                  outerIconColor={Theme.Color.$bgLight}
                />
                <span className="vf-task__bulk-edit__dialog__header__text">
                  {
                    Utils.TranslationHelper.replaceTag(
                      this.props.strings.page.dateWithSkipSuccess.header, {
                        count: result.successful_count,
                        total: result.successful_count + result.failed_count,
                      },
                    )
                  }
                </span>
              </div>

              <div className="vf-task__bulk-edit__dialog__description">
                {
                  Utils.TranslationHelper.replaceTag(
                    this.props.strings.page.dateWithSkipSuccess.description, {
                      skipped: result.failed_count,
                    },
                  )
                }
              </div>

              <Components.Button
                className="vf-task__bulk-edit__dialog__button"
                onClick={Utils.Dialog.DialogManger.close}
                text="Okay"
              />
            </div>
          ));
        }
      });
  }

  render() {
    const { strings } = this.props;

    return (
      <Components.AutoPositionContainer>
        <div className="vf-task__bulk-edit__panel">
          <div className="vf-task__bulk-edit__panel__content">
            <div className="vf-task__bulk-edit__panel__content__title">
              {strings.page.buttons.edit.dateTitle}
            </div>

            <BulkEditField iconClassName="versa-calendar-day">
              <Components.Input.DatePicker
                onChange={val => this._onFormChange('date', val)}
                value={this.state.form.date}
              />
              <div className="vf-task__bulk-edit__panel__content__description">
                {strings.page.buttons.edit.description}
              </div>
            </BulkEditField>

            <Components.Button
              className="vf-task__bulk-edit__panel__content__button"
              iconClassName="versa-completed"
              loading={this.props.isEditingMultiple}
              onClick={() => this._editMultiple()}
            />
          </div>
        </div>
      </Components.AutoPositionContainer>
    );
  }
}

BulkEditDropdownPanel.displayName = 'Bulk Edit Dropdown Panel';

BulkEditDropdownPanel.propTypes = {
  dispatch: PropTypes.func.isRequired,
  ids: PropTypes.arrayOf(),
  isEditingMultiple: PropTypes.bool,
  strings: PropTypes.shape().isRequired,
};

BulkEditDropdownPanel.defaultProps = {
  ids: [],
  isEditingMultiple: false,
};

function mapStateToProps(state) {
  const { task } = state;
  return {
    isEditingMultiple: task.isEditingMultiple,
  };
}

export default connect(mapStateToProps)(translate('Task')(BulkEditDropdownPanel));
